import React from 'react';
import SectionHeader from '@components/common/SectionHeader';

export interface TrendsSectionProps {
  title: string;
  headerNodeId: string;
  sectionNodeId: string;
  /** Anchor id used by the quick links row. */
  anchorId?: string;
  children: React.ReactNode;
}

/**
 * Section wrapper: red-left SectionHeader + a bordered white panel, with an
 * 8px gap between them (see PT02 / section 2). Panel content is passed in.
 */
const TrendsSection: React.FC<TrendsSectionProps> = ({
  title,
  headerNodeId,
  sectionNodeId,
  anchorId,
  children,
}) => (
  <section className="trends-section" id={anchorId} data-node-id={sectionNodeId}>
    <SectionHeader title={title} showHelp dataNodeId={headerNodeId} />
    <div className="trends-section__panel">{children}</div>
  </section>
);

export default TrendsSection;
